export default class BaseModel {
    constructor(data = undefined) {}
}


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/BaseModel.js